import React from "react";
import { List } from "../modules/TestInvoices";

export function InvoicesListPage() {
  return <List />;
}
